import { Exercise } from '@playground/models/exercise.model';
import { RunnerState } from './state';

export enum ActionsTypes {
  SetExercise = '[PLAYGROUND] SetExercise',
  SetRunner = '[PLAYGROUND] SetRunner',
}

export class SetExerciseAction {
  readonly type = ActionsTypes.SetExercise;

  constructor(public payload: Exercise) {}
}

export class SetRunnerAction {
  readonly type = ActionsTypes.SetRunner;

  constructor(public payload: Partial<RunnerState>) {}
}

export type Actions = SetExerciseAction | SetRunnerAction;
